export const USER_TUTOR: "tutor" = "tutor";
export const USER_GUARDIAN: "guardian" = "guardian";

export const TIME_FORMAT = "h a";
export const HOUR_CHOICE_START = 8;
